import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { faqs } from '../../data/faqs';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="border-t border-line bg-navy py-8 sm:py-12" aria-labelledby="faq-title" data-id="element-15" data-mp="zp453fm0d60l">
      <div className="mx-auto max-w-3xl px-5 sm:px-8" data-id="element-16" data-mp="urkrmhx4wx9p">
        <div id="faq-title" data-id="element-17" data-mp="70os0ymfsxrw">
          <SectionHeading title="Frequently Asked Questions" data-id="element-18" data-mp="71zy553cuhm6" />
        </div>

        <ul className="mt-6 divide-y divide-line border-y border-line" data-id="element-19" data-mp="22x38dh39rrx">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          const panelId = `faq-panel-${i}`;
          return <li key={faq.question} data-id="element-20" data-mp="bzi7gwlaayup" data-mpi={i}>
                <h3 data-id="element-21" data-mp="c2nxce1qm4rh">
                  <button type="button" aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-4 py-5 text-left font-display text-lg font-bold text-cream transition-colors duration-150 ease-out hover:text-pumpkin focus-visible:outline-none focus-visible:text-pumpkin" data-id="element-22" data-mp="1seb40fpdjxmd">
                    {faq.question}
                    <PlusIcon className={`h-5 w-5 shrink-0 text-pumpkin transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-23" data-mp="vts4bt86y1vl" />
                  </button>
                </h3>
                <div id={panelId} className={`grid transition-[grid-template-rows,opacity] duration-200 ease-out motion-reduce:transition-none ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} aria-hidden={!isOpen} data-id="element-24" data-mp="834jk7d6fhrm">
                  <div className="overflow-hidden" data-id="element-25" data-mp="nozf547x20vi">
                    <p className="pb-5 pr-8 text-base leading-relaxed text-muted" data-id="element-26" data-mp="nnodb9y17371">{faq.answer}</p>
                  </div>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}